import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
    SetEstate = '[ESTATE_ACT] SET_ESTATE',
    ResetEstate = '[ESTATE_ACT] RESET_ESTATE',
}
export const SetEstate = createAction(
    ActionTypes.SetEstate, //action name
    props<{ estateData: any }>() //parameter
);
export const ResetEstate = createAction(
    ActionTypes.ResetEstate //action name
);
